import React from "react"
import tw, { styled } from "twin.macro"

export enum IconPosition {
  Before = "before",
  After = "after",
}
interface StyleProps {
  iconPosition?: IconPosition
  onClick?: () => void
}
const StyledIcon = styled("span")(({ iconPosition, onClick }: StyleProps) => [
  tw`pl-3`,
  iconPosition === IconPosition.After && tw`pl-0 pr-3 order-2 cursor-default`,
  onClick && tw`cursor-pointer`,
])
interface Props {
  iconPosition?: IconPosition
  icon?: JSX.Element
  onClick?: () => void
}

// icon before is built in, we only need to defind if icon apears after.
// icon prop will take eyeIcon, dollarsign or component. please define other variations as components in parent level.
export type IconProps = Props & StyleProps
export const Icon = ({ icon, iconPosition, onClick }: IconProps) => {
  return (
    <>
      {icon && (
        <StyledIcon onClick={onClick} iconPosition={iconPosition}>
          {icon}
        </StyledIcon>
      )}
    </>
  )
}
export default Icon
